$(document).ready(function () {
  var ua = navigator.userAgent.toLowerCase(),
    event =
      ua.match(/Android/i) ||
      ua.match(/iPad/i) ||
      ua.match(/iPod/i) ||
      ua.match(/iPhone/i)
        ? "touchstart"
        : "click",
    isMobile = ua.match(/(iphone|ipod|ipad|android)/),
    window_w = $(window).width(),
    window_h = $(window).height(),
    is_home = $("body").hasClass("ishome");

  $.blockUI.defaults.message = "...";

  // $.cookieBar({
	// 	message: LANG.cookies_txt,
	// 	acceptText: LANG.cookies_btn,
	// 	fixed: true,
	// 	bottom: true,
	// 	policyButton: true,
	// 	policyText: LANG.cp_txt,
	// 	policyURL: LANG.cp_url,
	// });

  $("html").removeClass("no-js");

  if ("standalone" in window.navigator && window.navigator.standalone) {
    $("html").addClass("ios-standalone");
  }

  if ($.browser.msie) {
    $("html").addClass("is-ie");
    $("html").addClass("ie-" + $.browser.versionNumber);
  }

  if ($.browser.msedge) {
    $("html").addClass("is-edge");
  }

  if ($.browser.iphone && $.browser.safari) {
    $("html").addClass("ios-safari");
  }

  if ($.browser.iphone && $.browser.chrome) {
    $("html").addClass("ios-chrome");
  }

  if ($.browser.android && $.browser.chrome) {
    $("html").addClass("android-chrome");
  }

  if ($(".mh").length) {
    $(".mh").matchHeight(true);
  }

  /**
   * Embed responsive
   */
  var iframe = $(".site-main iframe");
  if (iframe.length) {
    iframe.wrap("<div class='embed'></div>");
  }

  function blockScroll(block) {
    if (block == 1) {
      $("html").addClass("block-scroll");
    } else if (block == 0) {
      $("html").removeClass("block-scroll");
    }
  }

  if ($(".mh").length) {
    $(".mh").matchHeight(true);
  }

  /**
   * Trigger AOS
   */
  setTimeout(function () {
    $("#loader").fadeOut(500, function () {
      $(this).remove();
    });
    $(".loading-container").fadeOut();
    AOS.init({
      offset: -50,
      disable: "mobile",
    });
  }, 300);

  /**
   * Fade loading images
   */
  var load_images_bg = $("body").find(
    ".load-img:not(.loaded), .load-img-uncover:not(.loaded)"
  );
  if (load_images_bg.length) {
    load_images_bg.each(function (index, element) {
      var image = new Image(),
        $element = $(element),
        is_bg_or_img = typeof $element.data("src") !== "undefined";

      image.onload = function () {
        if (is_bg_or_img) {
          $element
            .css("backgroundImage", "url('" + $element.attr("data-src") + "')")
            .removeAttr("data-src");
        }
        setTimeout(function () {
          $element.parent().removeClass("loading");
          $element.addClass("loaded");
        }, 200);
      };
      image.src = is_bg_or_img
        ? $element.attr("data-src")
        : $element.find("img").attr("src");
    });
  }

  /**
   * Lazy load images
   */
  var velcroLazy = {
    /**
     * init
     * correr on load e sempre que for necessário, por exemplo, a seguir a uma call ajax
     * elements: passar class dos ementos a fazer lazy load (ex: .lazy)
     * ex: velcroLazy.init('.lazy');
     */
    init: (elements) => {
      let lazyImages = $(elements);

      if ("IntersectionObserver" in window) {
        var lazyImageObserver = new IntersectionObserver(function (
          entries,
          observer
        ) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var lazyImage = $(entry.target),
                image = lazyImage.find("img")[0] || new Image(),
                is_bg_or_img = typeof lazyImage.data("src") !== "undefined";

              image.onload = function () {
                if (is_bg_or_img) {
                  //is bg
                  lazyImage
                    .css(
                      "backgroundImage",
                      "url('" + lazyImage.data("src") + "')"
                    )
                    .removeAttr("data-src");
                }
                setTimeout(function () {
                  lazyImage
                    .addClass("loaded")
                    .removeClass("lazy")
                    .parent()
                    .removeClass("loading");
                }, 200);
              };

              image.src = is_bg_or_img
                ? lazyImage.data("src")
                : lazyImage.find("img").attr("data-src");
              lazyImageObserver.unobserve(entry.target);
            }
          });
        });

        lazyImages.each(function () {
          lazyImageObserver.observe(this);
        });
      } else {
        lazyImages.each(function () {
          var is_bg_or_img = typeof $(this).data("src") !== "undefined";
          if (is_bg_or_img) {
            //is bg
            $(this)
              .css("backgroundImage", "url('" + $(this).data("src") + "')")
              .removeAttr("data-src");
          } else {
            //is img
            $(this)
              .find("img")
              .attr("src", $(this).find("img").data("src"))
              .removeAttr("data-src");
          }
          $(this)
            .addClass("loaded")
            .removeClass("lazy")
            .parent()
            .removeClass("loading");
        });
      }
    },
  };
  velcroLazy.init(".lazy");

  var root = $("html,body");
  function smoothScrollingTo(target) {
    var target = $(target);
    if (target.length) {
      root.animate(
        {
          scrollTop: target.offset().top - 170,
        },
        400,
        "swing"
      );
    }
  }

  $("a[href*=\\#]:not([href=\\#],[data-toggle],.open-popup)").on(
    "click",
    function (event) {
      smoothScrollingTo(this.hash);
      if ($(".menu-mobile").hasClass("show")) {
        toogleMenu();
      }
    }
  );

  smoothScrollingTo(location.hash);

  if (!Modernizr.objectfit) {
    $("body .objectfit").each(function () {
      var $container = $(this),
        imgUrl = $container.find("img").prop("src");
      if (imgUrl) {
        $container
          .css("backgroundImage", "url(" + imgUrl + ")")
          .addClass("compat-object-fit");
      }
    });
  }


  if ($('#accordion').length) {
		$('#accordion').find('.accordion-title').on('click', function () {
			if ($(this).find('span.arrow.down').length) {
				// $(this).removeClass('blue');
				$(this).find('span.arrow.down').removeClass('down');
				$(this).find('.accordion-desc').slideUp(200);
				$.bbq.pushState("#close");
			} else {
				$.bbq.pushState("#" + $(this).attr("data-url"));
			}
		});

		$(window).bind("hashchange", function (event) {

			var $target = $('#accordion-' + decodeURIComponent($.param.fragment()));

			if ($target.length) {
				$target.find('.accordion-desc').slideToggle(200, function () {
					$("body, html").stop().delay(100).animate({
						scrollTop: ($target.offset().top - 80)
					}, 400);
				});
				$('.accordion-title').not($target).removeClass('blue');
				// $target.toggleClass('blue');
				var thisspan = $target.find('span.arrow');
				$('.accordion-title span').not(thisspan).removeClass('down');
				$(thisspan).toggleClass('down');
				$(".accordion-desc:visible").not($target.find('.accordion-desc')).slideUp(200);
			}

		}).trigger("hashchange");
	}

  $('.wpcf7-select').parents('.wpcf7-form-control-wrap').append('<span class="select-arrow"></span>');

  $('.register-form-section .wpcf7-submit').parents('p').addClass('tac x-compensate');
  /**
   * Scroll do menu
   */
  windowOnScroll();
  $(window).on("scroll", function () {
    windowOnScroll();
  });

  /**
   * Abrir e fechar o menu
   */
  $("#toggle-menu").on("click", function () {
    var el = $(this);
    if (el.hasClass("opened")) {
      el.removeClass("opened");
      $(".mobile-menu-container").removeClass("show");
      blockScroll(0);
      
    } else {
      el.addClass("opened");
      $(".mobile-menu-container").addClass("show");
      blockScroll(1);
    }
  });

  var swiper = new Swiper(".courses-hero-slider", {
    slidesPerView: 1.1,
    spaceBetween: 20,
    navigation: {
      nextEl: ".button-next",
      prevEl: ".button-prev",
    },
    breakpoints: {
      // when window width is >= 320px
      1024: {
        slidesPerView: 2.6,
        spaceBetween: 20,
      },
      950: {
        slidesPerView: 2.3,
        spaceBetween: 20,
      },
      450: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
    },
  });

  var swiperBlog = new Swiper(".blog-slider", {
    slidesPerView: 3.5,
    spaceBetween: 20,
    navigation: {
      nextEl: ".blog-button-next",
      prevEl: ".blog-button-prev",
    },
    breakpoints: {
      // when window width is >= 320px
      1024: {
        slidesPerView: 3.8,
        spaceBetween: 20,
      },
      950: {
        slidesPerView: 2.3,
        spaceBetween: 20,
      },
      450: {
        slidesPerView: 1.8,
        spaceBetween: 20,
      },
      0: {
        slidesPerView: 1.1,
        spaceBetween: 20,
      },
    },
  });

  //console.log(letters);
/*=============================================================
    	PLAY BUTTON SHOW FANCYBOX VIDEO
	=============================================================*/
	/* $(".video-btn").fancybox({
		maxWidth	: 1025,
		maxHeight	: 580,
		fitToView	: false,
		width		: '100%',
		height		: '100%',
		autoSize	: false,
		closeClick	: false,
		openEffect	: 'none',
		closeEffect	: 'none',
		helpers	: {
			media: {},
			title	: null,
			overlay	: {
				showEarly : true,
				css : {
					'background' : 'rgba(0, 0, 0, 0.8)'
				}
			}
		}
	}); */

  /* $(".video-btn").fancybox({
		maxWidth	: 800,
		maxHeight	: 600,
		fitToView	: false,
		width		: '70%',
		height		: '70%',
		autoSize	: false,
		closeClick	: false,
		openEffect	: 'none',
		closeEffect	: 'none'
	}); */

  // $('.w-dropdown-toggle').hover(
  //   function() {
  //       // Add the "open" class to the element with class "w-dropdown-list"
  //       $('.w-dropdown-list').addClass('open');
  //   }, function() {
  //       // Remove the "open" class when stop hovering
  //       $('.w-dropdown-list').removeClass('open');
  //   }
  // );

  // When clicking on the element with class "w-dropdown-toggle"
  $('.w-dropdown-toggle').click(function() {
    $('.w-dropdown-list').toggleClass('open');
  });

});

/**
 * Block scroll
 * @param block
 */
function blockScroll(block) {
  if (block == 1) {
    $("html").addClass("block-scroll");
  } else if (block == 0) {
    $("html").removeClass("block-scroll");
  }
}

/**
 * Verificar se é um email válido
 */
function IsEmail(email) {
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email) ? true : false;
}

/**
 * Verifica se a checkbox de política de privacidade está ou não seleccionada
 */
function checkPolicy(form) {
  var checked = form.find('input[name="checkpolicy[]"]:checked').length;
  if (checked === 1) {
    return true;
  }

  return false;
}

/**
 * Window on scroll
 */
function windowOnScroll() {
  if ($(window).scrollTop() > 45 && !$("body").hasClass("scrolled")) {
    $("body").addClass("scrolled");
  } else if ($(window).scrollTop() <= 45 && $("body").hasClass("scrolled")) {
    $("body").removeClass("scrolled");
  }
}

function addEvent(event, selector, callback, context) {
  document.addEventListener(event, e => {
      if ( e.target.closest(selector) ) {
          callback(e);
      }
  });
}
addEvent('click', '.cmplz-show-banner', function(e){
  e.preventDefault();
  document.querySelectorAll('.cmplz-manage-consent').forEach(obj => {
      obj.click();
  });
});